import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import jwtService from 'services/jwtService';
import AuthService from "services/AuthService";


const initialState = {
    usageInfo : '',
    status : 'idle',
    error : {}
};


export const fetchUsagePlan = createAsyncThunk('data/fetchData', async (subscription_reference:string) => {
    try {
		const response = await jwtService.fetchRequest({
			method: 'GET',
			//url: `/entity.ashx?id=subscription:${subscription_reference}`,
            url: '/file.ashx?action=subcription',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
		});
		return response.data;
        //return response.data;
	} catch (error) {
		return error;
	}
});



const usagePlanStore = createSlice({
    name: 'usagePlanStore',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsagePlan.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUsagePlan.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.usageInfo = action.payload;
            })
            .addCase(fetchUsagePlan.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload ? action.payload : action?.error;
            });
        },
    
});

export default usagePlanStore.reducer;
